import React, { useState } from 'react'
import Header from '../../Header/header'
import Footer from '../../Footer/components/Footer'
import NewsLetter from '../../NewsLetter/components/NewsLetter_Page'
import '../styles/style.css'
import planKaleheImg from '../assets/000_33EN462.jpg'
import { useTranslation } from 'react-i18next'
import report2022Pdf from '../assets/Plan Kalehe - Securite climatique et prevention des catastrophes naturelles.pdf'
import { Modal } from 'react-bootstrap'


function Plans() {

	const { t } = useTranslation();
	const [showPDF, setShowPDF] = useState(false);
	const [pdfUrl, setPdfUrl] = useState('');

	const viewPDF = (pdfUrl) => {
		setPdfUrl(pdfUrl);
		setShowPDF(true);
	  };

	const closePDF = () => {
		setShowPDF(false);
		setPdfUrl('');
	  };

	return (
		<div className="plan_container">
			<Header />
			<div className="plan_contents">
				<div className="plan_detatils">
					<div className="plan_Intro">
						<h1>{t("plans_Intro")}</h1>
					</div>
				</div>
				
				
				<div className="plan_comp">
					<div className="plan_boxes">





						<div className="plan_box">
							<div className="plan_img">
								<img src={planKaleheImg} alt="" />
							</div>
							<div className="plan_txt">
								<div className="plan_texte">
									<h2 className="plan_texte_link">{t("plans_annuel_title_2022")}</h2>
									<p>{t("plans_annuel_desc_2022")}</p>
								</div>
								<div className="plan_button">
									<button onClick={() => viewPDF(report2022Pdf)}>{t("plans_view_button")}</button>
								</div>

							</div>
						</div>



					</div>
				</div>

				<div className="plan_follow">
					<div className="plan_follow_Intro">
						<h2>{t("plan_follow_Intro")}</h2>
						<h1>{t("plan_follow_follow")}</h1>

						<div className="plan_links">
							<div className="plan_link_icons">
								<a href="https://web.facebook.com/acndc.org" className="plan_link_icon">
									<i class="fab fa-facebook-f"></i>
								</a>
								<a href="https://x.com/ACNDC_ASBL?t=jwMpjWhuT4ScZgeAIa8juA&s=08" className="plan_link_icon">
									<i className="fab fa-twitter"/>
								</a>
								<a href="https://www.linkedin.com/company/acndc-asbl-organisation-f%C3%A9minine-de-base/" className="plan_link_icon">
									<i className="fab fa-linkedin"/>
								</a>
								<a href="https://instagram.com/acndc_asbl?igshid=MzNlNGNkZWQ4Mg==" className="plan_link_icon">
									<i className="fab fa-instagram"/>
								</a>
							</div>
						</div>
					</div>
				</div>


			</div>
			<NewsLetter />
			<Footer />

		{/* PDF Viewer Modal */}
			<Modal show={showPDF} onHide={closePDF} size="xl" centered dialogClassName="pdf-modal-wide">
				<Modal.Header closeButton>
					<Modal.Title>{t("plans_annuel_title_2022")}</Modal.Title>
				</Modal.Header>
				<Modal.Body style={{ height: '800px', padding: 0 }}>
					{pdfUrl && (
						<iframe
							src={`${pdfUrl}#toolbar=0`}
							style={{ width: '100%', height: '100%', border: 'none' }}
							title="PDF Viewer"
						></iframe>
					)}
				</Modal.Body>
			</Modal>
		</div>
	)
}

export default Plans